import React, { Component } from 'react';
import SequencesComponent from 'components/sequences/SequencesComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import ColorsComponent from './ColorsComponent.js';
import { connect } from "react-redux";
import {setViewMode, setLoadedTracks, setCurrentUserMix, setUserHasEditsToSave} from 'actions/index.js';
import MixPlayerPane from './MixPlayerPane.js';
import Tone from 'tone';
import SpotlightTrack from 'components/user/SpotlightTrack.js';
import ScriptableSequencerEngine from 'engine/ScriptableSequencer.js';
import Scripting from 'scripting/Scripting.js';
import ProfileNavigatorComponent from './ProfileNavigatorComponent.js';
import TracksComponent from './TracksComponent.js';
import AddTracksButton from './AddTracksButton.js';
import UserMix from 'repos/UserMix.js';
import UserMixesComponent from './UserMixesComponent.js';
import MixNameComponent from './MixNameComponent.js';
import LinksComponent from './LinksComponent.js';
import {SPOTLIGHT, MIXES, LINKS, COLORS} from 'constants/user-view-modes.js';

class UserProfileDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSequences: false,
            newMix: false,
        };

        this.loadTrack = this.loadTrack.bind(this);
        this.unloadTrack = this.unloadTrack.bind(this);
    }

    onClickAddTrack() {
        this.setState({showSequences: true});
    }

    hideSequences() {
        this.setState({showSequences: false});
    }

    getOrderedTracks() {
        if (this.props.viewMode == MIXES) {
            if (this.props.currentMix === undefined) {
                return [];
            }
            return new UserMix().fromJson(this.props.currentMix).tracks;
        }

        // if view mode is spotlight show the spotlight tracks
        // if view mode is mix then show the current mix's tracks
        return this.props.spotlightTracks.filter(
            (t) => this.props.multiSequencerEngine.getSequencerEngine(t.id) !== undefined)
            .concat(
                this.props.spotlightTracks.filter(
                    (t) => !this.props.multiSequencerEngine.getSequencerEngine(t.id)));
    }

    getTracks() {
        if (this.props.viewMode == MIXES) {
            if (this.props.currentMix === undefined) {
                return [];
            }
            return new UserMix().fromJson(this.props.currentMix).tracks;
        }

        return this.props.spotlightTracks;
    }

    getAllTracks() {
        let tracks = {};

        for (let i in this.props.spotlightTracks) {
            tracks[this.props.spotlightTracks[i].id] =
                this.props.spotlightTracks[i];
        }

        for (let i in this.props.mixes) {
            let mix = this.props.mixes[i];
            for (let j in mix.tracks) {
                tracks[mix.tracks[j].id] = mix.tracks[j];
            }
        }

        return Object.values(tracks);
    }

    filterLoadedTracks(tracks, loaded) {
        if (loaded) {
            let loadedTracks = new Set(this.props.loadedTracks);
            return tracks.filter(
                track => loadedTracks.has(track.id));
        }

        return tracks.filter(
            track => 
                !this.props.multiSequencerEngine.getSequencerEngine(track.id)
            );
    }

    loadTrack(id) {
        this.props.multiSequencerEngine.loadTrack(id);
        let loadedTracks = new Set(this.props.loadedTracks);
        loadedTracks.add(id);
        this.props.setLoadedTracks(Array.from(loadedTracks));
    }

    unloadTrack(id) {
        this.props.multiSequencerEngine.unloadTrack(id);
        let loadedTracks = new Set(this.props.loadedTracks);
        loadedTracks.delete(id);
        this.props.setLoadedTracks(Array.from(loadedTracks));
    }

    saveAsMix(tracks) {
        let mix = new UserMix();
        mix.tracks = tracks;
        this.props.setCurrentUserMix(mix.getJson());
        this.props.addEditedMix(mix);
        this.props.setUserHasEditsToSave(true);
        this.props.setViewMode(MIXES);
    }

    render() {
        if (this.props.sequencerEngineEditing !== undefined) {
            return (<div></div>);
        }

        if (this.props.viewMode === LINKS) {
            return (
                <LinksComponent
                  ethereum={this.props.ethereum}
                  userId={this.props.userId}/>
            );
        }

        return (
            <div className="profile-details">
              <div className="left-pane">
              <ConditionedComponent condition={this.props.viewMode == MIXES}>
                <MixNameComponent
                  isEditing={this.props.isEditing}
                  addEditedMix={this.props.addEditedMix}
                  currentMix={this.props.currentMix}/>
              </ConditionedComponent>
              <div className="spotlight-pane">
                <ConditionedComponent condition={!this.state.showSequences && (this.props.viewMode === SPOTLIGHT || this.props.currentMix !== undefined)}>
                  <AddTracksButton
                    viewMode={this.props.viewMode}
                    userLoaded={this.props.userLoaded}
                    isEditing={this.props.isEditing}
                    onClickAddTrack={() => this.onClickAddTrack()}/>
                </ConditionedComponent>
                <ConditionedComponent condition={this.props.currentMix === undefined && this.props.viewMode == MIXES}>
                  <UserMixesComponent isEditing={this.props.isEditing} onClickDeleteMix={this.props.onClickDeleteMix} mixes={this.props.mixes}/>
                </ConditionedComponent>
               </div>
              <div className="clear-fix"/>
                <TracksComponent
                  multiSequencerEngine={this.props.multiSequencerEngine}
                  loadTrack={this.loadTrack}
                  unloadTrack={this.unloadTrack}
                  tracks={this.getTracks()}
                  isEditing={this.props.isEditing}
                  ethereum={this.props.ethereum}
                  onEditSequence={this.props.onEditSequence}
                  onDeleteTrack={this.props.onDeleteTrack}
                  store={this.props.store}/>
              </div>
              <div>
                <MixPlayerPane
                  isEditing={this.props.isEditing}
                  saveAsMix={(tracks) => this.saveAsMix(tracks)}
                  multiSequencerEngine={this.props.multiSequencerEngine}
                  tracks={this.filterLoadedTracks(this.getAllTracks(), true)}
                  >
                  <TracksComponent
                    isPlayable={true}
                    multiSequencerEngine={this.props.multiSequencerEngine}
                    userId={this.props.userId}
                    tracks={this.filterLoadedTracks(this.getAllTracks(), true)}
                    loadTrack={this.loadTrack}
                    unloadTrack={this.unloadTrack}
                    isEditing={this.props.isEditing}
                    ethereum={this.props.ethereum}
                    onEditSequence={this.props.onEditSequence}
                    onDeleteTrack={this.props.onDeleteTrack}
                    store={this.props.store}/>
                </MixPlayerPane>
              <ConditionedComponent condition={this.state.showSequences}>
                <div className="sequences-chooser-wrapper">
                  <div onClick={() => this.hideSequences()} className="add-spotlight-track">
                    HIDE
                  </div>
                  <SequencesComponent
                    filterByUser={this.props.viewMode === SPOTLIGHT}
                    onLoad={(id) => this.props.addTrack(id)}>
                  </SequencesComponent>
                </div>
              </ConditionedComponent>
              </div>
             </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLoadedTracks: (tracks) => dispatch(setLoadedTracks(tracks)),
        setCurrentUserMix: (mix) => dispatch(setCurrentUserMix(mix)),
        setUserHasEditsToSave: (flag) => dispatch(setUserHasEditsToSave(flag)),
        setViewMode: (mode) => dispatch(setViewMode(mode))
    };
};

export default connect(undefined, mapDispatchToProps)(UserProfileDetails);
